import React from "react";
import Test from "./test";

const info = {
  difficulty: "easy",
  title: "Check if integer",
  url: "check-if-integer",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {number} num
* @return {boolean}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function isInteger(num) {
  // your code goes here        
};
`,
};

export default info;
